import style from '../css/Report.module.css';
import Header from './Header';
import ViewContainer from './ViewContainerRC';

function ReportCardSetting(jsonData) {
    return (
        <div className={style.container}>
            <Header />
            <ViewContainer jsonData={jsonData} />
        </div>
    );
}

export default ReportCardSetting;